import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  TApplicationsDocIdRemoteBankingContacts,
  TFormApplications,
} from '~/store/remote-banking-contacts/types.ts';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';
import { TBaseRequest } from '~/store/types.ts';

export const remoteBankingContactsManagerForm = createAsyncThunk<
  TApplicationsDocIdRemoteBankingContacts,
  TFormApplications
>(
  'remoteBankingContacts/managerForm',
  async ({ applicationId, form, token }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      };

      const response = await api.put(
        `/remote-banking-contacts/applications/${applicationId}`,
        form,
        { headers }
      );

      return response.data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const remoteBankingContactsManager = createAsyncThunk<{ documentId: string }, TBaseRequest>(
  'remoteBankingContacts/managerForms',
  async ({ applicationId, token }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      };

      const response = await api.post(
        `/remote-banking-contacts/applications/${applicationId}/documents/personal-data-agreement`,
        null,
        { headers }
      );

      return response.data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
